<template>
  <div class="ActivityDiscount">
    <img :src="imgUrl" alt="大方租车 押金双免"/>
    <div class="getActivityDiscount"></div>
  </div>
</template>

<script>
  import { orderSource } from "@/utils/env";
  import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
  export default {
    name: 'solicitation',
    data(){
      return {
        imgUrl: 'https://cms.dafang24.com/aliapp/2020/solicitation.png'
      }
    },
    created () {},
    mounted () {},
    methods: {

    }
  }
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .getActivityDiscount {
      position: absolute;
      left: 0; top: 0;
      width: 100%;
      height: 100%;
      /*background-color: rgba(0,0,0, .5);*/
    }
  }
</style>